import firebase from "firebase/app";

export default {
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      if (vm.$store.state.profile != null) {
        vm.screenTransitionLog(vm, to);
      }
    });
  },
  methods: {
    writeLog: async function(result, log) {
      var idToken = await firebase.auth().currentUser.getIdTokenResult(false);
      await this.writeLogWithIdToken(idToken.token, result, log);
    },
    writeLogWithIdToken: async function(idToken, result, log) {
      if (log.length > 200) {
        log = log.substr(0, 200);
        log = log + "...";
      }
      // 対象API呼び出し
      var response = await this.$http.post(
        this.$store.state.management.backend.api.writeLog,
        // リクエストパラメータを作成
        {
          result: result,
          log: log,
        },
        {
          // ヘッダーにIDトークンを付与する
          headers: {
            idToken: idToken,
          },
        }
      );
      if (response.data.errorCode !== "") {
        // 例外スロー
        throw response;
      }
    },
    screenTransitionLog: async function(vm, to) {
      try {
        await vm.writeLog(
          "success",
          "画面遷移 - " + to.meta.title + "(" + to.path + ")"
        );
      } catch (error) {
        vm.$store.commit("app/showErrorDialog", true, { root: true });
        vm.$store.commit("app/showErrorMessage", "ログ書き込み失敗", {
          root: true,
        });
        if (error.status === 200) {
          vm.$store.commit("app/showErrorCode", error.data.errorCode, {
            root: true,
          });
        } else {
          vm.$store.commit("app/showErrorCode", error.message, { root: true });
        }
      }
    },
  },
};
